export default <S extends string>(s: S): Uncapitalize<S> => {
  return `${s.charAt(0).toLowerCase()}${s.slice(1)}` as Uncapitalize<S>
}